export const reParseLatLngArray = (array) => {
  let points = []
  array.forEach(val => points.push([parseFloat(val[0]), parseFloat(val[1])]))
  return points
}
